import { useEffect, useRef, useState } from 'react';

type TInputmask = typeof import('inputmask').default;

// https://robinherbots.github.io/Inputmask/
export const useInputMask = (
    regex?: string,
    placeholder?: string,
    mask?: string,
    showMaskOnFocus = true,
    focus = false,
    alias?: string,
    inputFormat?: string,
) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const inputmaskRef = useRef<TInputmask | null>(null);

    useEffect(() => {
        const input = inputRef?.current;
        let isMounted = true;

        if (input) {
            if (focus) {
                input.focus();
            }

            import(/* webpackChunkName: "inputmask" */ 'inputmask').then((module) => {
                if (!isMounted) {
                    return;
                }
                const Inputmask = (module.default || module) as unknown as TInputmask;
                inputmaskRef.current = Inputmask;

                Inputmask({
                    mask,
                    placeholder,
                    regex,
                    showMaskOnFocus,
                    alias,
                    inputFormat,
                }).mask(input);
                input.setAttribute('data-mask-ready', 'true');
            }).catch((error) => {
                console.error('Error loading Inputmask', error);
            });
        }
        return function cleanup() {
            isMounted = false;
            if (input) {
                if (inputmaskRef.current) {
                    inputmaskRef.current.remove(input);
                }
                input.removeAttribute('data-mask-ready');
            }
        };
    }, [placeholder, regex, mask, showMaskOnFocus, focus, alias, inputFormat]);
    return inputRef;
};
export const useSimpleInput = (value: string) => {
    const [inputValue, setInputValue] = useState(value);
    const [isFocused, setIsFocused] = useState<boolean>(!!value);
    const [isFilled, setIsFilled] = useState<boolean>(!!value);
    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const value = e?.target?.value;
        setIsFocused(false);
        setIsFilled(!!value);
    };

    const handleFocus = () => {
        setIsFilled(true);
        setIsFocused(true);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e?.target?.value);
    };
    return {
        handleChange,
        handleBlur,
        handleFocus,
        isFilled,
        isFocused,
        inputValue,
    };
};
